/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from './OnboardingTypeResponse.types.tsx';
import { fetchOnboardingType } from './fetchOnboardingType.tsx';

export const actions: {
	readonly fetchOnboardingType: (
		projectId: number | undefined,
		projectType: string | undefined, // eslint-disable-next-line @typescript-eslint/no-explicit-any
	) => Action<State, any>;
} = {
	fetchOnboardingType,
} as const;

export type Actions = typeof actions;
